/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Show_Project_InfoInputs */

const en_editor_show_project_info = /** @type {(inputs: Editor_Show_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Project Info`)
};

const fr_editor_show_project_info = /** @type {(inputs: Editor_Show_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher les informations du projet`)
};

const de_editor_show_project_info = /** @type {(inputs: Editor_Show_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektinformationen anzeigen`)
};

const it_editor_show_project_info = /** @type {(inputs: Editor_Show_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra informazioni sul progetto`)
};

const ru_editor_show_project_info = /** @type {(inputs: Editor_Show_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать информацию о проекте`)
};

const es_editor_show_project_info = /** @type {(inputs: Editor_Show_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar información del proyecto`)
};

const zh_cn2_editor_show_project_info = /** @type {(inputs: Editor_Show_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示项目信息`)
};

const ja_editor_show_project_info = /** @type {(inputs: Editor_Show_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト情報を表示`)
};

const hi_editor_show_project_info = /** @type {(inputs: Editor_Show_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट की जानकारी दिखाएँ`)
};

const pt_pt2_editor_show_project_info = /** @type {(inputs: Editor_Show_Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar informações do projeto`)
};

/**
* | output |
* | --- |
* | "Show Project Info" |
*
* @param {Editor_Show_Project_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_show_project_info = /** @type {((inputs?: Editor_Show_Project_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Show_Project_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_show_project_info(inputs)
	if (locale === "de") return de_editor_show_project_info(inputs)
	if (locale === "it") return it_editor_show_project_info(inputs)
	if (locale === "ru") return ru_editor_show_project_info(inputs)
	if (locale === "es") return es_editor_show_project_info(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_show_project_info(inputs)
	if (locale === "ja") return ja_editor_show_project_info(inputs)
	if (locale === "hi") return hi_editor_show_project_info(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_show_project_info(inputs)
	return en_editor_show_project_info(inputs)
});